module.exports = __webpack_public_path__ + "static/media/calendar.e6451ac3.svg";